module.exports = __webpack_public_path__ + "img/cxc.a7210515.jpg";